var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M239.9,10h-32c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1h25.8v25.8c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1v-32C246,12.7,243.3,10,239.9,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M239.9,201.8c-3.4,0-6.1,2.7-6.1,6.1v25.8h-25.8c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1h32c3.4,0,6.1-2.7,6.1-6.1v-32C246,204.5,243.3,201.8,239.9,201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16.1,54.2c3.4,0,6.1-2.7,6.1-6.1V22.3h25.8c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1h-32c-3.4,0-6.1,2.7-6.1,6.1v32C10,51.5,12.7,54.2,16.1,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M39.5,120.6h81.1V39.5H39.5V120.6z M54.2,54.2h51.7v51.7H54.2V54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M48.1,233.7H22.3v-25.8c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1v32c0,3.4,2.7,6.1,6.1,6.1h32c3.4,0,6.1-2.7,6.1-6.1C54.2,236.5,51.5,233.7,48.1,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M66.6,66.6h26.9v26.9H66.6V66.6L66.6,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M216.5,39.5h-81.1v81.1h81.1V39.5z M201.8,105.9h-51.7V54.2h51.7V105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M162.5,66.6h26.9v26.9h-26.9V66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M39.5,216.5h81.1v-81.1H39.5V216.5z M54.3,150.1h51.6v51.6H54.3V150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M69,164.9h22.1V187H69V164.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M189.5,189.5h-13.5v-13.5h13.5v-13.5h-13.5v-13.6h-13.5v-13.5h-13.5v13.5h-13.5v13.6v13.5h13.5v13.5h-13.5V203h13.5v13.5h13.5l0,0h13.5V203h13.5v13.5h13.5V203h13.5v-13.6h-13.5v-13.5h-13.5L189.5,189.5L189.5,189.5z M162.4,175.9h-13.5v-13.5h13.5V175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M203,148.9v-13.5h-13.5h-13.5v13.5h13.5v13.6H203v13.5h13.5v-13.5v-13.6H203z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "res/media/qr_code.d8cd74f5e6a5c8dfedde7bebe937d8c5.svg";
export { ForwardRef as ReactComponent };